import { motion } from 'framer-motion'

function About() {
  const fadeInUp = {
    hidden: { opacity: 0, y: 60 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
      },
    },
  }

  const fadeInLeft = {
    hidden: { opacity: 0, x: -60 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
        delay: 0.2,
      },
    },
  }

  const fadeInRight = {
    hidden: { opacity: 0, x: 60 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
        delay: 0.4,
      },
    },
  }

  return (
    <motion.div
      className="min-h-screen bg-gray-900"
      initial="hidden"
      animate="visible"
      variants={{
        hidden: { opacity: 0 },
        visible: {
          opacity: 1,
          transition: {
            staggerChildren: 0.3,
          },
        },
      }}
    >
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute rounded-full -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-orange-200/30 to-blue-200/30 blur-3xl animate-pulse-slow"></div>
        <div
          className="absolute rounded-full -bottom-40 -left-40 w-80 h-80 bg-gradient-to-tr from-blue-200/30 to-orange-200/30 blur-3xl animate-pulse-slow"
          style={{ animationDelay: '1s' }}
        ></div>
        <div className="absolute transform -translate-x-1/2 -translate-y-1/2 rounded-full top-1/2 left-1/2 w-96 h-96 bg-gradient-to-r from-orange-100/20 to-blue-100/20 blur-3xl animate-float"></div>
      </div>

      <div className="relative z-10 py-12 mx-auto max-w-7xl px-4">
        <motion.section className="px-6" variants={fadeInUp}>
          <div className="grid items-center order-1 gap-12 lg:grid-cols-2 lg:px-0">
            {/* Left Content */}
            <motion.div className="relative h-full" variants={fadeInLeft}>
              <div className="relative h-full bg-center bg-cover rounded-2xl sm:h-full">
                <div className="relative z-10 flex flex-col justify-center text-center sm:h-full">
                  <img
                    src="/crypto-bg.jpg"
                    alt="Customer Experience"
                    className="w-full rounded-3xl"
                  />
                </div>
              </div>
            </motion.div>

            <motion.div className="text-white" variants={fadeInRight}>
              <h1 className="mb-6 text-4xl font-bold leading-tight lg:text-6xl">
                Unlock higher approvals, <span className="text-orange-400">instant liquidity</span>,
                and bigger profits
                {/* for <span className="text-orange-400">High-Risk</span> Merchants */}
              </h1>
              <p className="max-w-2xl mb-8 text-gray-300">
                Our platform is built for businesses that demand reliability and protection. With no
                chargebacks, merchants can accept payments confidently, free from the risks and
                disputes common in traditional payment systems.
              </p>
              <div className="flex flex-col gap-4 mb-8 sm:flex-row"></div>
            </motion.div>

            {/* Right Visual - 3D Safe with Coins */}
          </div>
        </motion.section>

        <motion.section
          className="p-6 lg:p-16 lg:my-20 bg-slate-800 rounded-3xl"
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <div className="grid items-center order-1 gap-12 lg:grid-cols-2 lg:p-0">
            {/* Left Content */}
            <motion.div className="relative h-full" variants={fadeInLeft}>
              <h1 className="mb-6 text-4xl font-bold leading-tight text-white lg:text-6xl">
                Who, <span className="text-orange-400">We are</span>.
              </h1>
              <p className="text-white">
                Our platform is built for businesses that demand reliability and protection. With no
                chargebacks, merchants can accept payments confidently, free from the risks and
                disputes common in traditional payment systems. To further guarantee security and
                compliance, PexiLabs is fully PCI-DSS certified, adhering to the highest standards
                for safeguarding sensitive financial data.
              </p>
            </motion.div>

            <motion.div className="text-white" variants={fadeInRight}>
              <p className="pb-4 mx-auto font-light text-gray-300 max-w-7xl">
                At PexiLabs, we are revolutionizing the way payments are made by connecting the
                world of traditional finance with the fast-growing crypto economy. As a leading
                payment gateway provider, we enable card-to-crypto transactions that are seamless,
                instant, and secure.
              </p>

              <p className="mx-auto font-light text-gray-300 max-w-7xl">
                Whether you are an online merchant, fintech innovator, or digital asset platform,
                PexiLabs provides the tools you need to expand into the global crypto economy. Our
                mission is simple: to power fast, secure, and risk-free payments, giving businesses
                and consumers the confidence to transact in a digital-first world.
              </p>
              <div className="flex flex-col gap-4 mb-8 sm:flex-row"></div>
            </motion.div>

            {/* Right Visual - 3D Safe with Coins */}
          </div>
        </motion.section>

        <motion.section
          className="p-6 mx-auto my-6 bg-white lg:my-0 max-w-8xl rounded-3xl"
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          <img src="/currency.png" className="mx-auto " />
        </motion.section>
      </div>
    </motion.div>
  )
}

export default About
